import React, { forwardRef } from 'react'
import Dialog from '@mui/material/Dialog'
import Slide from '@mui/material/Slide'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import { NotificationsActiveRounded } from '@mui/icons-material'
import {
  promptPaperSx,
  PromptBody,
  PromptIcon,
  PromptTitle,
  PromptText,
  PromptActions,
  ActivateButton,
  LaterButton,
} from './styles'

const SlideUp = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />)
SlideUp.displayName = 'SlideUp'

// Invitación propia antes del permiso del navegador: Chrome solo muestra su ventana
// de permiso si sale de un toque del usuario, por eso se pide con el botón "Activar".
function NotificationsPrompt({ open, onActivate, onDismiss }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Dialog
      open={open}
      onClose={onDismiss}
      TransitionComponent={isMobile ? SlideUp : undefined}
      PaperProps={{ sx: promptPaperSx(isMobile) }}
      aria-labelledby="notifications-prompt-title"
    >
      <PromptBody>
        <PromptIcon aria-hidden>
          <NotificationsActiveRounded />
        </PromptIcon>
        <PromptTitle id="notifications-prompt-title" component="h2">
          Activa las notificaciones
        </PromptTitle>
        <PromptText>
          Te avisamos cuando tu moto se encienda, se apague o reporte una alarma.
        </PromptText>
        <PromptActions>
          <ActivateButton variant="contained" disableElevation onClick={onActivate}>
            Activar
          </ActivateButton>
          <LaterButton onClick={onDismiss}>Ahora no</LaterButton>
        </PromptActions>
      </PromptBody>
    </Dialog>
  )
}

export { NotificationsPrompt }
